let $header = jQuery();

const getHeaderHeight = () => {
  $header = $header.length ? $header : jQuery('.header');
  return $header.length ? $header.outerHeight() : 0;
};

export { getHeaderHeight };
